module.exports = __webpack_public_path__ + "static/img/home-pub-rs.74f5a901.jpg";